import { MOTION_VARIANTS } from "_constants";
import { StyledAppAnimatePage } from "./index.styled";
import PropTypes from "prop-types";

const AppAnimatePage = (props) => {
  const { children, path, noAnimation } = props;
  if (noAnimation) return children;
  return (
    <StyledAppAnimatePage
      custom={{ direction: "forward" }}
      initial="initial"
      animate="in"
      exit="out"
      variants={MOTION_VARIANTS}
      key={path}
    >
      {children}
    </StyledAppAnimatePage>
  );
};

AppAnimatePage.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
  noAnimation: PropTypes.bool,
};

AppAnimatePage.defaultProps = {
  noAnimation: false,
};

export default AppAnimatePage;
